import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "400",
  height: "400",
  fill: "currentColor",
  class: "icon",
  viewBox: "0 0 1024 1024"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M996.83 355.43 759.5 118.1a92.75 92.75 0 0 0-131.19 0L511.95 234.47 395.69 118.21a92.87 92.87 0 0 0-131.16 0L27.18 355.54a92.75 92.75 0 0 0 0 131.19L446.36 905.9a92.76 92.76 0 0 0 131.19 0l237.33-237.33 181.95-181.95a92.77 92.77 0 0 0 0-131.19M660.39 566.7a36.81 36.81 0 0 0-16.12 62.41l53 53-27 27-53-53a36.82 36.82 0 1 0-52.05 52.06l53 53-27 27-53.05-53A36.82 36.82 0 1 0 486 787.29l53 53-13.54 13.52a19.15 19.15 0 0 1-27 0L79.26 434.64a19.15 19.15 0 0 1 0-27l237.32-237.37a19.16 19.16 0 0 1 27 0l116.31 116.26-79.1 79.1 45.8 45.83a120.74 120.74 0 0 0 164.26 6l172 172a19.15 19.15 0 0 1 0 27L749.3 630l-53-53a36.8 36.8 0 0 0-35.91-10.3m-3.79-214.55a36.81 36.81 0 1 0-52.09-52l-59.24 59.24a47.13 47.13 0 0 1-59.78 5.61L680.4 170.16a19.15 19.15 0 0 1 27 0l237.37 237.33a19.15 19.15 0 0 1 0 27L827 552.3a93 93 0 0 0-12.12-14.92L643.13 365.63z" }, null, -1)
  ])))
}
export default { render: render }